import BpkRating, {
  RATING_SIZES,
  RATING_SCALES,
} from '@skyscanner-internal/backpack-web/bpk-component-rating';
import classnames from 'classnames';

import { withI18n } from '../../hotels-utils/services/i18n';
import scoreSummaryForReview from '../../hotels-utils/services/score';
import { getAriaHidden } from '../../utils/a11y';

import { RATING_KEY_MAP } from './rating-key-map';

import type { I18n } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

import STYLES from './ReviewRating.module.scss';

type ReviewRatingProps = {
  i18n: I18n;
  className?: string;
  score: number;
  count?: number;
  image?: string;
  vertical?: boolean;
  index?: number;
  showReviewImage?: boolean;
};

const ReviewRating = ({
  className = undefined,
  count = undefined,
  i18n,
  image = undefined,
  index = undefined,
  score,
  showReviewImage = false,
  vertical = false,
}: ReviewRatingProps) => {
  if (!score || !count) {
    return null;
  }

  const formatScore = i18n.formatNumber(score, 1);
  const formatCount = i18n.formatNumber(count, 0);
  const ratingKey = scoreSummaryForReview(score);

  let ariaLabel = image
    ? i18n.translate('aria_trip_advisor_review_rating', {
        score,
        count,
      })
    : i18n.translate('aria_trip_com_review_rating', {
        desc: ratingKey && i18n.translate(RATING_KEY_MAP[ratingKey]),
        score,
        count,
      });

  ariaLabel = Array.isArray(ariaLabel) ? ariaLabel.join('') : '';

  const useImageTitle = showReviewImage && image;

  const title = useImageTitle ? (
    <img src={image} className={STYLES.ReviewRating__image} alt="" />
  ) : (
    ratingKey && i18n.translate(RATING_KEY_MAP[ratingKey])
  );

  const subtitle: string =
    count > 9
      ? i18n.translate('Reviews_label_X', {
          0: formatCount,
        })
      : i18n.translatePlural('Reviews_label_', count, 'number', {
          0: formatCount,
        });

  return (
    <BpkRating
      className={classnames(STYLES.ReviewRating, className)}
      ariaLabel={ariaLabel}
      aria-hidden={getAriaHidden(index)}
      value={formatScore}
      title={title}
      ratingScale={RATING_SCALES.zeroToFive}
      subtitle={Array.isArray(subtitle) ? subtitle.join('') : ''}
      showScale={!useImageTitle}
      size={vertical ? RATING_SIZES.large : RATING_SIZES.base}
    />
  );
};

export default withI18n(ReviewRating);
